import { useMemo } from 'react';
import LocalizationStorage from '%app/js/common/services/localizationStorage';
import createFullReloadHistory from './fullReloadHistory';

export default function useLocaleReloadHistory() {
    const locale = LocalizationStorage.getLocalizationContext();
    return useMemo(() => createFullReloadHistory({ basename: `/${locale}` }), [locale]);
}
